import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

export const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>

export const getEntries = Object.entries as <T extends object>(obj: T) => Array<[keyof T, T[keyof T]]>
